import LoginLayout from 'components/template/Login.jsx';
import useLogin from 'hooks/useLogin';
import { useEffect } from 'react';

const Login = () => {

  const { isLogin, moveToPath } = useLogin();

  useEffect(()=>{
    if (isLogin) {
      moveToPath("/main");
    }
  }, [isLogin]);

  return (
    <LoginLayout />
  );
}

export default Login;
